import { render } from "./PopupOffer.vue?vue&type=template&id=4da658ab&scoped=true"
import script from "./PopupOffer.vue?vue&type=script&lang=js"
export * from "./PopupOffer.vue?vue&type=script&lang=js"

import "./PopupOffer.vue?vue&type=style&index=0&id=4da658ab&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4da658ab"]])

export default __exports__